import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                <div className="col-md-12">
                    <div className="about-desc">
                    <span className="heading-meta">About Us</span>
                    <h2 className="colorlib-heading">Who Am I?</h2>
                    <p> Results-oriented Mobile developer with more than 12+ years experience in development. I make it my goal to create mobile applications with the user in mind, creating applications with a usable and intuitive user interface experience.</p>
                    <p>I also understand the importance of creating highly readable and easily maintainable source code. I am constantly striving to learn new technologies and look to ways to better myself in this rapidly changing industry. </p>
                    <p> ■ Around 12+ years of experience in the area of software development for mobiles and web, which includes understanding requirement specification, working on software design, coding, testing and maintenance. 
                    </p>
                    <p> ■ 8.5+ years of experience in native iPhone/iPad (iOS, Xcode) application development using objective-C, Swift, Cocoa Touch on iOS platform, frameworks and customizing it as per requirements. </p>
                    <p> ■ Familiar with Agile Scrum and Waterfall methodologies | Experience in Mobile DevOps process and Strong understanding of its practices </p>
                    <p> ■ Experience in unit testing with XCTest using XCUI Testing Framework and native approaches and Test Driven Development. </p>
                    <p> ■ Good understanding of React JS base web application and React mobile app's development  </p>
                    <p> ■ Experience in iOS design patterns like MVC, Notification, MVVM, VIPER, Coordinator and development best practices. </p>
                    <p> ■ Experience building mobile applications that utilize web services (HTTP, XML, JSON or other services). | Deep exposure of Mobile Application Development Frameworks, Design Guidelines, design patterns. | Strong understanding of interactive application development paradigms, memory management, file I/O, concurrency and multi-threading. </p>
                    <p> ■ Experience in back-end database technologies like SQL, embedded database SQLite and offline storage using Core Data.</p>
                    <p> ■ Knowledge in developing Enterprise level Mobile Applications includes code signing, provisioning and publishing applications in App Store satisfying Apple publishing procedures and App review process. </p>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
        <section className="colorlib-about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">What I do?</span>
                <h2 className="colorlib-heading">Here are some of my expertise</h2>
            </div>
            </div>
            <div className="row row-pt-md">
            <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3> iOS Application Development</h3>
                    <p>As coming from the iOS app development background, I have deep exposure of Mobile  interactive application development</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                <span className="icon">
                    <i className="icon-bulb" />
                </span>
                <div className="desc">
                    <h3>Web Development </h3>
                    <p>I have experience building websites and chrome extentions using JavaScript,React JS,HTML,CSS &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Dev Ops</h3>
                    <p>I am having good Knowledge of mobile apps DevOps and working with tools like Jenkins, fastlane, Azue DevOps</p>
                </div>
                </div>
            </div>
            {/*
            <div className="col-md-4 text-center animate-box">
                <div className="services color-2">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Dev Ops</h3>
                    <p>Jenkins , Kubernetes , Docker </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-4">
                <span className="icon">
                    <i className="icon-layers2" />
                </span>
                <div className="desc">
                    <h3>Graphic Design</h3>
                    <p>My friend knows .. P</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-6">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Digital Marketing</h3>
                    <p>I use Instagram eight hours a day :) </p>
                </div>
                </div>
            </div>
            */}
            </div>
        </div>
        </section>
      </div>
    )
  }
}
